import { AreaTargetFormationBase } from './base/area-target-formation-base';

export class AreaTargetFormation extends AreaTargetFormationBase { }